import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {type Component} from "../Component";
import {type ProgramPhase} from "../Phase";

interface ProgramPhaseComponent extends DeserializedRecord<"program_phase_component"> {
  programComponent: Component
  programPhase: ProgramPhase
}

interface ProgramPhaseComponentData extends JSONAPIRecord {
  relationships: {
    program_component: JSONAPISingleRelationship,
  }
}

const deserializeProgramPhaseComponent: Deserializer<ProgramPhaseComponent, ProgramPhaseComponentData> = (data, included) => {
  const programComponent = deserializeSingleRelationship<Component>(data.relationships.program_component, included);

  return ({
    programComponent,
    ...deserializeItem(data)
  });
};

export {
  deserializeProgramPhaseComponent
};

export type {
  ProgramPhaseComponent
};
